import React, { useEffect, useState } from 'react';
import SectionTitle from "../UI/SectionTitle";
import BlogItem from "./blogItem";


import {useHomeBlog} from './../../queries/homeBlog';
import InfinitProgressBar from '../InfiniteProgressBar';


function Blog() {

    const {error, loading, data} = useHomeBlog();
    if(loading) return <InfinitProgressBar/>
    if(error) return <div>error!</div>

    return (
        <div className="blog-area-wrapper sm-top">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <div style={{width:'10%', height:"5px", backgroundColor:'red', margin:"auto" }}/><br/>
                        <SectionTitle title=" " heading="آخرین به روزرسانی ها"  txtcolor="#000"/>
                    </div>
                </div>

                <div className="row mtn-35">
                    {
                        data.blog.map(blog =>(
                            <BlogItem key={blog.contentItemId} alias={blog.alias.alias} id={blog.contentItemId} title={blog.displayText} excerpt={blog.blogOverview.html} postBy={blog.blogAuthor} date={blog.blogCreateDate}/>
                        ))
                    }
                </div>
            </div>
        </div>
    );
}

export default Blog;
